import Vue from 'vue'
import VMoney from './directive'
import options from './options'

export {
  options, VMoney
}

function install(Vue, globalOptions) {

  if (globalOptions) {
    Object.keys(globalOptions).forEach(function (key) {
      options[key] = globalOptions[key]
    })
  }

  Vue.directive('formatMoney', VMoney);

}

export default install

Vue.use(install)
